// import UserContext from 'contexts/UserContext'
// import React, { useContext, useEffect } from 'react'
// import IconUpdateProfile from '../../assets/iconUpdateProfile.svg'
// import { fr } from "date-fns/locale"

// import UpdateInfo from './updateInfo'
// import * as Yup from 'yup'
// import { ErrorMessage, useFormik } from 'formik'
// import DatePicker from 'react-datepicker'

import UserContext from 'contexts/UserContext'
import React, { useContext, useEffect, useState } from 'react'
import IconUpdateProfile from '../../assets/iconUpdateProfile.svg'
import Homme from '../../assets/logoHomme.svg'
import Femme from '../../assets/logoFemme.svg'
import UpdateInfo from './updateInfo'
import * as Yup from 'yup'
import { useFormik } from 'formik'
// import 'react-datepicker/dist/react-datepicker.css'


type infoPersonnel =
  {
    firstName: string,
    lastName: string,
    // selectedOption: string,
    // dateNaissance: string

  }

interface Props {
  isValidInfoPersonnel: boolean,
  HandleFieldFocus: () => void
  isUpdatInfoPersonnel: boolean,
  setIsUpdatInfoPersonnel: (val: boolean) => void
  setErrorValuePersonnelInfo: (val: boolean) => void
  setIsKyc: (val: boolean) => void
  setInfoPersonnel: (liste: infoPersonnel) => void
}

const InformationPersonnellesProfile: React.FC<Props> = ({ isValidInfoPersonnel, HandleFieldFocus,

  isUpdatInfoPersonnel, setIsUpdatInfoPersonnel,
  setInfoPersonnel, setErrorValuePersonnelInfo,
  setIsKyc
}) => {
  const { user } = useContext(UserContext)

  const dateString = user?.user?.birthDate
  const datePart = dateString ? dateString.split('T')[0] : null
  const minDate = new Date(1910, 1, 1)
  const today = new Date()
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())

 


  const validationSchema = Yup.object({

    firstName: Yup
      .string()
      .matches(/^[a-zA-ZÀ-ÿ\u00C0-\u017F\s'’œŒæÆçÇ-]+$/, 'Des lettres uniquement')
      .test('valid-spaces', 'Ce champ est requis', value => {
        if (!value) return false
        { return !/^\s| {2,}/.test(value) }

      })
      .test('at-least-two-letters', 'Ce champ doit contenir au moins deux lettres', value => {
        if (!value) return true
        const letters = (value.match(/[a-zA-ZÀ-ÿ]/g) || []).length
        return letters >= 2
      })
      .required('Ce champ est requis'),

    lastName: Yup
      .string()
      .matches(/^[a-zA-ZÀ-ÿ\u00C0-\u017F\s'’œŒæÆçÇ-]+$/, 'Des lettres uniquement')
      .test('valid-spaces', 'Ce champ est requis', value => {
        if (!value) return false
        { return !/^\s| {2,}/.test(value) }

      })
      .test('at-least-two-letters', 'Ce champ doit contenir au moins deux lettres', value => {
        if (!value) return true
        const letters = (value.match(/[a-zA-ZÀ-ÿ]/g) || []).length
        return letters >= 2
      })
      .required('Ce champ est requis'),


  
  })


  const formik = useFormik({
    initialValues: {

      firstName: user?.user?.personalInfo?.firstName,
      lastName: user?.user?.personalInfo?.lastName,
      // dateNaissance: user?.user.birthDate
  
    },


    validationSchema,
    onSubmit: async (values) => {
      console.log('onsubmit', values)

    }
  })

  useEffect(() => {
    const hasError = Object.keys(formik.errors).length > 0
    setErrorValuePersonnelInfo(hasError)
    setIsKyc(formik.dirty)

  }, [formik.errors, formik.dirty])

  useEffect(() => {

    setInfoPersonnel({

      firstName: formik.values.firstName || '',
      lastName: formik.values.lastName || '',
      // dateNaissance: user?.user.birthDate || ''
    
    })
  }, [formik.values])

useEffect(()=>{
  if(!isUpdatInfoPersonnel){
        formik.resetForm({
              values: {
                ...formik.values,
                firstName: user?.user?.personalInfo?.firstName,
                lastName: user?.user?.personalInfo?.lastName,
                // dateNaissance: user?.user.birthDate 
                // selectedOption: user?.user.personalInfo.gender,

              }
            })
      }
},[isUpdatInfoPersonnel])

  return (
    <div> 
      <div className='flex items-center justify-between mb-[24px]'>

        <h3 className="h3 ">Informations personnelles </h3>

        {isValidInfoPersonnel ?
          (!isUpdatInfoPersonnel ?
          <img className='cursor-pointer'
            onClick={() => { setIsUpdatInfoPersonnel(true) }}
            src={IconUpdateProfile}
            alt='setting info Adress'
          />
          :
          <div onClick={() => {
            setIsUpdatInfoPersonnel(false)
            formik.resetForm({
              values: {
                ...formik.values,
                firstName: user?.user?.personalInfo?.firstName,
                lastName: user?.user?.personalInfo?.lastName,
                // dateNaissance: user?.user.birthDate 
                // selectedOption: user?.user.personalInfo.gender,

              }
            })

          }} className='text-[#5754E5]  font-semibold cursor-pointer  hover:text-[#4D36CC] '>Annuler</div>
)
    :(<div></div>)
        }
      </div>

      <div className="border w-full  rounded-lg p-2  px-4 ">

        <div className="flex justify-between h-14   mt-3">
          <div className="text-[15px] sm:text-[13px] font-semibold text-[#6B7280]">Identifiant My Easy</div>
          <div className="text-[15px] sm:text-[13px] font-semibold text-[#35258B]">{user?.user?.order}</div>
        </div>

        <UpdateInfo onFocus={HandleFieldFocus} formik={formik} infoValue2={user?.user?.personalInfo?.firstName} title='Nom' isUpdate={isUpdatInfoPersonnel} fieldName="firstName" />
       
        <UpdateInfo onFocus={HandleFieldFocus} formik={formik} infoValue2={user?.user?.personalInfo?.lastName} title='Prénom' isUpdate={isUpdatInfoPersonnel} fieldName="lastName" />

        <div className="flex justify-between h-14    ">
          <div className="text-[15px] sm:text-[13px] font-semibold text-[#6B7280]">Genre</div>
          <div className="text-[15px] sm:text-[13px] font-semibold text-[#35258B]">
              {!user?.user?.personalInfo?.gender ? '_' : user?.user?.personalInfo?.gender === 'female' ? 'Femme' : 'Homme'}
          </div>
          
        </div>

        <div className="flex justify-between h-14   ">
          <div className="text-[15px] sm:text-[13px]  font-semibold text-[#6B7280]">Date de naissance</div>
          
          <div className="text-[15px] sm:text-[13px] font-semibold text-[#35258B]">{user?.user?.birthDate ? datePart : '_'}</div>
           {/* <div className='h-[80px] w-[170px] lg:w-[150px] flex flex-col items-start'>
              <DatePicker
                onFocus={HandleFieldFocus}
                onBlur={formik.handleBlur}
                 selected={
                      formik.values.dateNaissance
                        ? new Date(formik.values.dateNaissance)
                        : null
                    }
                placeholderText="jj/mm/aaaa"
                dateFormat="dd/MM/yyyy"
                locale={fr}
              
                onChange={ (e)=> {formik.handleChange(e)}}
                name="dateNaissance"
                wrapperClassName="relative w-full "
                className=" w-full outline-none border border-[#AEB6FB] placeholder:text-[#D1D1FF] rounded-[14px] h-[48px] focus:border-[#5754E5] text-[#35258B] pl-3"
                calendarClassName="shadow-lg custom-calendar h-[270px] "
                showIcon
                toggleCalendarOnIconClick
                calendarIconClassname="absolute bottom-3 right-3 cursor-pointer"
                maxDate={maxDate}
                minDate={minDate}
                autoComplete="off"
              />
              
            </div> */}
      
        </div>

        <div className="flex justify-between h-14   ">
          <div className="text-[15px] sm:text-[13px]  font-semibold text-[#6B7280]">Pays de naissance</div>
          <div className="text-[15px] sm:text-[13px] font-semibold text-[#35258B]">{user?.user?.countryOfBirth?.name ? user?.user?.countryOfBirth?.name : '_'}</div>
        </div>
      </div>
    </div>
  )
}
export default InformationPersonnellesProfile
